export default "__VITE_ASSET__UOJOCUhb__"